// extracted by mini-css-extract-plugin
module.exports = {"container":"Notes_container__P4U6p","visibleContainer":"Notes_visibleContainer__8hC3J"};